export const Status = {
	IN_PROGRESS: 'in-progress',
	SUGGESTION: 'suggestion',
	PLANNED: 'planned',
	LIVE: 'live',
};

// enum RequestStatus {
// 		UPPER_CASE = 'istediyin sey'
// }

export const statues = [
	{
		label: 'Suggestion',
		value: 'suggestion',
		color: 'black',
	},
	{
		label: 'Planned',
		value: 'planned',
		color: '#F49F85',
	},
	{
		label: 'In-Progress',
		value: 'in-progress',
		color: '#AD1FEA',
	},
	{
		label: 'Live',
		value: 'live',
		color: '#62BCFA',
	},
];
